"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InvoiceLineMeterReadingSelector = class InvoiceLineMeterReadingSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getPayload(...args) {
        const [data] = args;
        const fields = this.target && this.targetConfig[this.target].fieldsToSubmit;
        return fields ? _.pick(data, fields) : data;
    }
    isServiceStale(...args) {
        const [service] = args;
        return service.valid_to && this.$fn.parseISODate(service.valid_to) < this.today;
    }
    onCheckChanged(...args) {
        const [service] = args;
        const selection = _
            .chain(service.readings)
            .filter({ selected: true })
            .reverse()
            .value();
        const consumptions = [];
        selection.forEach((item, index) => {
            const nextItem = selection[index + 1];
            if (nextItem == null) {
                return;
            }
            consumptions.push({
                $key: item.id + nextItem.id,
                meter: service.meter,
                from_date: item.reading_date,
                from_amount: item.value,
                from_unit: item.unit,
                to_date: nextItem.reading_date,
                to_amount: nextItem.value,
                to_unit: nextItem.unit,
                billing_multiplier: service.meter_factor,
                diff: nextItem.value - item.value,
            });
        });
        service.consumptions = consumptions;
    }
    rental;
    onRental(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rental");
    }
    multiple;
    onMultiple(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("multiple");
    }
    serviceId;
    onService_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("serviceId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    services;
    async $$load_services() {
        return this.$fn.fetch('query_meter_readings', {
            parameters: {
                rental: this.rental,
                service_id: this.serviceId
            },
            asResource: true
        })
            .then(data => _
            .chain(data.services)
            .orderBy(['valid_from', 'inactive'], ['desc', 'asc'])
            .map(svc => (svc.readings = _.reverse(svc.readings).map((p, i) => (p.selected = (i < 2), p)),
            this.onCheckChanged(svc),
            svc))
            .value());
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['services', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                services: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("InvoiceLineMeterReadingSelector|Title", "Choose readings"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7070_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1969262983629788_closeModal_7074_getActionArgs($event) {
        return {
            result: {
                value: $event.scope.cons,
            },
        };
    }
    async evh_1969262983629788_clickPreventStop(event, scope) {
        return await this.actions.evh_1969262983629788_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_7391797828980767_script_7076_getActionArgs_value($event) {
        this.onCheckChanged($event.scope.item);
    }
    async act_7391797828980767_script_7076_getActionArgs($event) {
        return {
            value: () => this.act_7391797828980767_script_7076_getActionArgs_value($event),
        };
    }
    async evh_7391797828980767_change(event, scope) {
        return await this.actions.evh_7391797828980767_change.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeModal_7078_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7070 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7070_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7069 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7070,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7069],
        });
        const act_2248226175642056_closeComponent_7072 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_7071 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_7072,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_7071],
        });
        const act_1969262983629788_closeModal_7074 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1969262983629788_closeModal_7074_getActionArgs,
            events: [],
        });
        const evh_1969262983629788_clickPreventStop_7073 = new core_1.actions.EventHandlerImpl({
            action: act_1969262983629788_closeModal_7074,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1969262983629788_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1969262983629788_clickPreventStop_7073],
        });
        const act_7391797828980767_script_7076 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7391797828980767_script_7076_getActionArgs,
            events: [],
        });
        const evh_7391797828980767_change_7075 = new core_1.actions.EventHandlerImpl({
            action: act_7391797828980767_script_7076,
            event: "change",
            displayName: "script",
        });
        const evh_7391797828980767_change = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7391797828980767_change_7075],
        });
        const act_1548630417156826_closeModal_7078 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1548630417156826_closeModal_7078_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_7077 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_7078,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_7077],
        });
        return {
            act_7315092382398562_closeModal_7070,
            evh_7315092382398562_close_7069,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_7072,
            evh_2248226175642056_close_7071,
            evh_2248226175642056_close,
            act_1969262983629788_closeModal_7074,
            evh_1969262983629788_clickPreventStop_7073,
            evh_1969262983629788_clickPreventStop,
            act_7391797828980767_script_7076,
            evh_7391797828980767_change_7075,
            evh_7391797828980767_change,
            act_1548630417156826_closeModal_7078,
            evh_1548630417156826_clickPreventStop_7077,
            evh_1548630417156826_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceLineMeterReadingSelector.prototype, "rental", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rental'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLineMeterReadingSelector.prototype, "onRental", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], InvoiceLineMeterReadingSelector.prototype, "multiple", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('multiple'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLineMeterReadingSelector.prototype, "onMultiple", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceLineMeterReadingSelector.prototype, "serviceId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('serviceId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLineMeterReadingSelector.prototype, "onService_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], InvoiceLineMeterReadingSelector.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceLineMeterReadingSelector.prototype, "onSize", null);
InvoiceLineMeterReadingSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoiceLineMeterReadingSelector);
exports.default = InvoiceLineMeterReadingSelector;
vue_property_decorator_1.Vue.component("InvoiceLineMeterReadingSelector", InvoiceLineMeterReadingSelector);
